import 'svgxuse';
import './helpers/_service';
// import './modules/test';
import './modules/swiper';
import {$dom} from './helpers/dom';
import initSwiper from './modules/swiper';
import initNav from './modules/nav';
import initScrollSpy from './modules/scrollSpy';
import initForm from './modules/form';
import initMap from './modules/map';

$dom.ready(()=>{
  initSwiper()
  initNav()
  initScrollSpy()
  initForm()
  initMap()
})



